import { useMemo } from 'react';
import { transformFilterPropertyOverrideForNewFilterEditor } from '../utils/filterPropertyUtils';
import useContentPlatformPropertiesConfiguration from './useContentPlatformPropertiesConfiguration';
const useFilterEditorProps = () => {
  const {
    propertyDefinitionMap,
    quickFilterPropertyNames
  } = useContentPlatformPropertiesConfiguration();
  return useMemo(() => {
    const transform = transformFilterPropertyOverrideForNewFilterEditor(propertyDefinitionMap, quickFilterPropertyNames);
    return {
      propertyOverride: {
        // transform is only for standard properties received in the CRM Object Properties API response
        // This will hide all properties from the CRM Object Schema except what we consider to be
        // "standard" in the UI. It also manually transforms all such properties in propertyDefinitionMap to have full Property definition
        transform,
        // Need to run transform on all properties in propertyDefinitionMap since `transform` is only
        // run on the framework-listing-lib side for properties that are in the CRM Object Properties API response.
        // We define some properties on the FE that wouldn't be in that response, so they need to be treated the same.
        propertyMap: Object.keys(propertyDefinitionMap).reduce((acc, key) => {
          acc[key] = transform(propertyDefinitionMap[key]);
          return acc;
        }, {})
      }
    };
  }, [propertyDefinitionMap, quickFilterPropertyNames]);
};
export default useFilterEditorProps;